"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var TheSelect_1 = __importDefault(require("../TheSelect"));
exports.default = (function (props) {
    var defaultOptions = props.defaultOptions, loadOptions = props.loadOptions, value = props.value, onChange = props.onChange, onBlur = props.onBlur, restProps = __rest(props, ["defaultOptions", "loadOptions", "value", "onChange", "onBlur"]);
    var _a = React.useState(''), inputValue = _a[0], setInputValue = _a[1];
    var _b = React.useState({}), optionsByQuery = _b[0], setOptionsByQuery = _b[1];
    var typingDebounce = React.useRef();
    function handleChangeInputValue(newInputValue) {
        setInputValue(newInputValue);
        setOptionsByQuery(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[newInputValue] = __assign(__assign({}, prevState[newInputValue]), { isFetching: true }), _a)));
        });
        window.clearTimeout(typingDebounce.current);
        typingDebounce.current = window.setTimeout(function () {
            if (loadOptions) {
                loadOptions(newInputValue).then(function (loadedOptions) {
                    setOptionsByQuery(function (prevState) {
                        var _a;
                        return (__assign(__assign({}, prevState), (_a = {}, _a[newInputValue] = __assign(__assign({}, prevState[newInputValue]), { isFetching: false, options: loadedOptions }), _a)));
                    });
                });
            }
        }, 200);
    }
    var options = defaultOptions || [];
    var isFetching = false;
    if (inputValue) {
        if (optionsByQuery[inputValue]) {
            options = optionsByQuery[inputValue].options || [];
            if (optionsByQuery[inputValue].isFetching) {
                isFetching = true;
            }
        }
    }
    return (React.createElement(TheSelect_1.default, __assign({ value: value, onChange: onChange, onBlur: function () {
            setInputValue('');
            if (onBlur) {
                onBlur();
            }
        }, loading: isFetching, options: options, onChangeInput: handleChangeInputValue }, restProps)));
});
